/**
 * Format a phone number automatically based on its country prefix.
 * Supports: US (+1), Nepal (+977)
 *
 * @param phone - The raw phone number string (e.g. "6176321010", "+9779801234567")
 * @returns Formatted phone number string
 */

export function formatPhoneNumber(phone: string | null): string {
  if (!phone) return "";

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, "");

  let country: "US" | "NP" | "UNKNOWN" = "UNKNOWN";

  if (digits.startsWith("1") && digits.length === 11) country = "US";
  else if (digits.startsWith("977") && digits.length === 13) country = "NP";
  else if (digits.length === 10 && /^[2-9]\d{9}$/.test(digits)) country = "US";

  switch (country) {
    //US
    case "US": {
      const normalized =
        digits.length === 11 && digits.startsWith("1")
          ? digits.slice(1)
          : digits;
      if (normalized.length === 10) {
        const area = normalized.slice(0, 3);
        const mid = normalized.slice(3, 6);
        const last = normalized.slice(6);
        return `+1 (${area}) ${mid}-${last}`;
      }
      break;
    }

    //Nepal
    case "NP": {
      const local = digits.slice(3); // remove 977
      if (local.length === 9 || local.length === 10) {
        return `+977-${local.slice(0, 3)}-${local.slice(3)}`;
      }
      break;
    }

    default:
      return digits;
  }

  return phone;
}
